import React from 'react';
import { FAQ_ITEMS } from '../data/siteData';
import { useFormModal } from '../context/FormModalContext';

const FaqPage = () => {
    const { openForm } = useFormModal();

    return (
        <div className="page">
            <div className="container page-container">
                <h1 className="page-title">Часто задаваемые вопросы</h1>

                <div className="faq-list">
                    {FAQ_ITEMS.map(({ question, answer }) => (
                        <details key={question} className="faq-item">
                            <summary>{question}</summary>
                            <p>{answer}</p>
                        </details>
                    ))}
                </div>

                <p className="page-note">Не нашли ответ? Оставьте заявку — мы перезвоним и проконсультируем.</p>

                <button type="button" className="cta-button" onClick={openForm}>
                    Оставить заявку
                </button>
            </div>
        </div>
    );
};

export default FaqPage;
